import React from "react";
import "./HeroSection.css";
import "./CompeteHeroSection.css";
import "./GameCard.css";
import Fade from "react-reveal/Fade";
import LazyAnimation from "./LazyAnimation";
import { Button } from "./Button";

function ShareOmniOneSection({
  lightBg,
  lightText,
  lightTextDesc,
  extraPad,
  headline,
  description,
  description2,
  buttonLabel,
  buttonLink,
  img,
  alt,
  imgStart,
  noButton,
}) {
  return (
    <>
      <div className={extraPad ? "hero-section-text-extra-padding hero-section-gray-bg" : "hero-section-gray-bg"}>
        <div
          className={
            lightBg
              ? "hero-section-text"
              : "hero-section-text hero-section-dark-bg"
          }
        >
          <div className="hero-section-container">
            <div
              className="hero-section-row"
              style={{
                display: "flex",
                flexDirection: imgStart === "start" ? "row-reverse" : "row",
              }}
            >
              <div className="hero-section-col">
                <LazyAnimation></LazyAnimation>
                <Fade bottom cascade duration={800}>
                  <div className="hero-section-text-wrapper">
                    <h1
                      className={
                        lightText
                          ? "hero-section-heading"
                          : "hero-section-heading hero-section-text-dark"
                      }
                    >
                      {headline}
                    </h1>
                    <p
                      className={
                        lightTextDesc
                          ? "hero-section-subtitle"
                          : "hero-section-subtitle hero-section-text-dark"
                      }
                    >
                      {description}
                    </p>
                    <p
                      className={
                        lightTextDesc
                          ? "hero-section-subtitle-no-margin"
                          : "hero-section-subtitle-no-margin hero-section-text-dark"
                      }
                    >
                      {description2}
                    </p>
                    <a style={{
                display: noButton === "noButton" ? "none" : "block",
              }} href={buttonLink} target="_blank" rel="noreferrer">
                    <Button buttonSize="btn-wide" buttonColor="green">
                {buttonLabel}{" "}
                <div className="gamecard-right-arrow">
                  <img src="/images/arrow-icon-now.svg" alt="arrow" />
                </div>
              </Button>
              </a>
                  </div>
                </Fade>
              </div>
              <div className="hero-section-col">
                <div className="hero-section-img-wrapper">
                  <img src={img} alt={alt} className="hero-section-img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShareOmniOneSection;
